import { HeadCell } from "./types";

export const headCells = (t: (key: string) => string): HeadCell[] => {
  return [
    {
      id: "id",
      align: "left",
      disablePadding: true,
      label: t("case-code"),
    },
    {
      id: "ownerRole",
      align: "center",
      disablePadding: false,
      label: t("case-owner"),
    },
    {
      id: "caseProvince",
      align: "center",
      disablePadding: false,
      label: t("case-city"),
    },
    {
      id: "createDate",
      align: "center",
      disablePadding: false,
      label: t("create-date"),
    },
    {
      id: null,
      align: "right",
      disablePadding: false,
      label: t("review"),
    },
  ];
};
